module.exports = "/img/_/_/_/assets/images/creeper/battle/common//7.jpg?d3177c194d2f2819f707d704344a940c";